import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AssignmentService } from '@/services/assignment-student.service';
import { TrackingService } from '@/services/tracking.service';
import { ConfigService } from '@/services/config.service';

import { Assignment } from '@/structures/assignment';

@Component({
    selector: 'app-content-completed',
    templateUrl: './content-completed.component.html',
    styleUrls: ['./content-completed.component.scss'],
    standalone: false
})
export class ContentCompletedComponent implements OnInit {
    @Output() openErrorDialog: EventEmitter<string> = new EventEmitter();
    recommandedActivity: Assignment;

    constructor(
        private assignmentService: AssignmentService,
        private trackingService: TrackingService,
        private configService: ConfigService,
        private dialogRef: MatDialogRef<ContentCompletedComponent>,
        @Inject(MAT_DIALOG_DATA) public contentCompleted: Array<Assignment>
    ) {}

    ngOnInit() {
        this.assignmentService.getLastContent().subscribe((data) => {
            this.recommandedActivity = data.next_activity_in_order;
        });
    }

    getIcon(content) {
        return this.assignmentService.getIcon(content);
    }

    getContentLevel(content) {
        switch (content.level) {
            case 'parcours': {
                return 'le parcours';
            }
            case 'bloc': {
                return 'le bloc';
            }
            case 'competence': {
                return 'la compétence';
            }
            case 'module': {
                return 'le module';
            }
            case 'sequence': {
                return 'la séquence';
            }
        }
    }

    getRecommandedActivityIcon() {
        if (this.recommandedActivity) {
            return this.assignmentService.getIcon(this.recommandedActivity);
        }
    }

    getRecommandedActivityTitle() {
        if (this.recommandedActivity) {
            return this.recommandedActivity.title;
        }
    }

    getRecommandedActivityEndDate() {
        if (this.recommandedActivity) {
            return this.recommandedActivity.timeend;
        }
    }

    canLaunchContent() {
        return this.assignmentService.canLaunchContent(this.recommandedActivity);
    }

    launchContent($event: Event): void {
        $event.stopImmediatePropagation();
        if (this.canLaunchContent) {
            this.closeDialog();
            this.assignmentService.launchContent(this.recommandedActivity);
        }
    }

    /**
     * Ferme la fenêtre d'erreur
     */
    closeDialog() {
        this.dialogRef.close();
    }
}
